import {useAtom} from 'jotai'
import {snackbarMessagesState} from '@frnt/base/atoms'

export const useQueueSnackbarMessage = () => {
  const [snackbarMessages, setSnackbarMessages] = useAtom(snackbarMessagesState)
  return (snackbarMessage) => {
    setSnackbarMessages([...snackbarMessages, snackbarMessage])
  }
}
